import request from './request'

export interface LoginParams {
  username: string
  password: string
}

export interface LoginResult {
  token: string
  userId: number
  username: string
  tenantId: number
  roles: string[]
}

export function login(data: LoginParams): Promise<LoginResult> {
  return request.post('/v1/auth/login', data)
}

export interface DingTalkScanParams {
  corpId: string
  authCode: string
}

export interface DingTalkScanResult {
  bound: boolean
  dingtalkUserId: string
  userId?: number
  tenantId?: number
  username?: string
  token?: string
}

export function dingtalkScan(data: DingTalkScanParams): Promise<DingTalkScanResult> {
  return request.post('/v1/auth/dingtalk/scan', data)
}

export function dingtalkLogin(data: { appId: number; authCode: string }): Promise<DingTalkScanResult> {
  return request.post('/v1/auth/dingtalk/login', data)
}

export function getDingTalkScanConfig(corpId: string): Promise<{ corpId: string; appKey: string; agentId: string }> {
  return request.get('/v1/auth/dingtalk/config', { params: { corpId } })
}

export function changeMyPassword(oldPassword: string, newPassword: string): Promise<void> {
  return request.post('/v1/users/me/password', { oldPassword, newPassword })
}
